import React, { ForwardedRef, FocusEvent } from 'react';
import { InputProps, Input } from '@cad-arc';

export const resolveTime = (rawTime: string): string => {
    const sanitizedTime = rawTime
        .split('')
        .filter((v) => v !== ':')
        .join('');

    if (rawTime === '' || rawTime === undefined || rawTime === null) {
        return '';
    } else if (!/^\d+$/.test(sanitizedTime)) {
        return '00:00';
    } else {
        if (sanitizedTime.length === 1) {
            return `00:0${sanitizedTime}`;
        } else if (sanitizedTime.length === 2 && parseInt(sanitizedTime) < 60) {
            return `00:${sanitizedTime}`;
        } else if (sanitizedTime.length === 3 && parseInt(sanitizedTime.slice(1, 3)) < 60) {
            return `0${sanitizedTime.charAt(0)}:${sanitizedTime.slice(1, 3)}`;
        } else if (
            sanitizedTime.length > 3 &&
            parseInt(sanitizedTime.slice(0, 2)) < 24 &&
            parseInt(sanitizedTime.slice(2, 4)) < 60
        ) {
            return `${sanitizedTime.slice(0, 2)}:${sanitizedTime.slice(2, 4)}`;
        } else {
            return '00:00';
        }
    }
};

export const TimeInput = React.forwardRef(
    (props: InputProps, ref: ForwardedRef<HTMLInputElement>): React.ReactElement => {
        return (
            <Input
                {...props}
                ref={ref}
                onBlur={(e: FocusEvent<HTMLInputElement>) => {
                    if (e.target?.value !== null) {
                        e.target.value = resolveTime(e.target.value);
                        props.onChange?.(e);
                        props.onBlur?.(e);
                    }
                }}
            />
        );
    }
);
